import type { Size } from '@ui/types/base/size'

const sizeMap = {
  xs: { text: 'text-xs', padding: 'px-1 min-h-6', icon: 'size-6' },
  sm: { text: 'text-sm', padding: 'px-2 py-0.5 min-h-8', icon: 'size-8' },
  md: { text: 'text-base', padding: 'px-4 py-1 min-h-9', icon: 'size-9' },
  lg: { text: 'text-lg', padding: 'px-6 py-2 min-h-10', icon: 'size-10' }
}

export const useSize = (size: Size) => {
  if (!size || !sizeMap[size]) return sizeMap.md

  const { text, padding, icon } = sizeMap[size]

  return { text, padding, icon }
}
